import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CircularProgress, Box } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';

// Lazy load pages for better performance
const Home = React.lazy(() => import('./pages/Home'));
const Instructors = React.lazy(() => import('./pages/Instructors'));
const InstructorProfile = React.lazy(() => import('./pages/InstructorProfile'));
const Timetable = React.lazy(() => import('./pages/Timetable'));
const Studios = React.lazy(() => import('./pages/Studios'));
const News = React.lazy(() => import('./pages/News'));
const Contact = React.lazy(() => import('./pages/Contact'));
const NotFound = React.lazy(() => import('./pages/NotFound'));

// Loading component
const LoadingSpinner = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '50vh'
    }}
  >
    <CircularProgress sx={{ color: '#4bade6' }} />
  </Box>
);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/instructors" element={<Instructors />} />
            <Route path="/instructors/:instructorId" element={<InstructorProfile />} />
            <Route path="/timetable" element={<Timetable />} />
            <Route path="/studios" element={<Studios />} />
            <Route path="/locations" element={<Navigate to="/studios" replace />} />
            <Route path="/news" element={<News />} />
            <Route path="/contact" element={<Contact />} />

            {/* SEO URL Redirects - matching sitemap.xml */}
            <Route path="/bromley-studio-hire" element={<Navigate to="/studios" replace />} />
            <Route path="/dance-classes-bromley" element={<Navigate to="/timetable" replace />} />
            <Route path="/yoga-classes-bromley" element={<Navigate to="/timetable" replace />} />
            <Route path="/pilates-classes-bromley" element={<Navigate to="/timetable" replace />} />

            {/* 404 Catch-all - must be last */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Router>
    </ThemeProvider>
  );
}

export default App;
